import { apiClient } from "@/api/apiClient";

export const fetchAssigneesByEstateAsync = (
  estateId: number,
  clientConfig = {},
) => {
  return apiClient(clientConfig).get(`/estates/${estateId}/assignees`);
};
